<script lang="ts">
  import type { RadarAvatarPerson } from "../model";
  import PersonAvatar from "./PersonAvatar.svelte";

  let { people, id, maxVisible = 8, muted = false, label = "Participants" }: {
    people: RadarAvatarPerson[]; id: string; maxVisible?: number; muted?: boolean; label?: string;
  } = $props();
  let visible = $derived(people.slice(0, maxVisible));
  let overflow = $derived(Math.max(0, people.length - visible.length));
</script>

<div class="avatar-cluster" role="group" aria-label={label}>
  {#each visible as person, index (`${person.id}-${index}`)}
    <PersonAvatar {person} {muted} tooltipId={`${id}-avatar-${index}-tooltip`} />
  {/each}
  {#if overflow > 0}<span class="avatar-overflow" aria-label={`${overflow} more participants`}>+{overflow}</span>{/if}
</div>
